import { render, staticRenderFns } from "./vcSelectUser.vue?vue&type=template&id=5a5deaf0&"
import script from "./vcSelectUser.vue?vue&type=script&lang=js&"
export * from "./vcSelectUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports